import SetPasswordLinkAcceptedPage from "./SetPasswordLinkAcceptedPage";

export default SetPasswordLinkAcceptedPage;
